Vue.filter('decimal', function (value, places) {
    if (!value) return '0.00'
    if (!places) places = 2
    value = +value
    return value.toFixed(places)
})